var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"good-list"},_vm._l((_vm.goodsList),function(item,index){return _c('goods-list-item',{key:index,staticClass:"good-list-item",attrs:{"good":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }